import { ReactElement } from "react";
import { Navigate } from "react-router-dom";
import { useUser } from "../../context";

interface Props {
  fallback?: string;
  children: ReactElement;
}

// RequireAbility only knows abilities; the OC module is also a per-company opt-in flag
// (`purchaseOrderModuleEnabled`). Compose this with <RequireAbility> on every OC route so a
// deep-link is blocked when the module is off, even for a user who holds the ability.
const RequirePurchaseOrderModule = ({ fallback = "/", children }: Props) => {
  const { purchaseOrderModuleEnabled } = useUser();
  return purchaseOrderModuleEnabled ? (
    children
  ) : (
    <Navigate to={fallback} replace />
  );
};

export default RequirePurchaseOrderModule;
